import React from 'react';
import { Theme } from '@mui/material/styles';
import { createStyles, makeStyles } from '@mui/styles';
import { ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { getReferringCompany } from '../../../core/utils/ReferringCompanyValueGetter/ReferringCompanyValueGetter';
import {
  NavLink as RouterLink,
  NavLinkProps as RouterLinkProps,
} from 'react-router-dom';
import { ReactComponent as SAFlag } from '../../../core/assets/CountriesList/countries/south-africa.svg';
import { ACCOUNT_SECTION_ROUTE, CDSA_REFERRING_VALUE } from '../../../core/utils/Constants/Constants';
import { withTranslate } from '../../../core/TenantProvider';
import { MenuItem } from './menuItems';

interface ListItemLinkProps {
  icon?: React.ReactElement;
  primary: string;
  to: string,
  drawerOpen?: boolean,
  translate: Function,
  onMenuClick?: (item: MenuItem) => void,
  item: MenuItem
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingTop: 12,
      paddingBottom: 12,
    },
    listItem: {
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
    selection: {
      borderLeft: "4px #FFF solid",
      "&:hover, &.active": {
        borderLeft: "4px #2D91E9 solid",
        background: "#f5f5f5",

      },
      "&.active": {
        '& .MuiListItemText-primary': {
          fontWeight: 'bold'
        }
      }
    },
    selected: {
      borderLeft: '4px solid #2D91E9',
      backgroundColor: '#f5f5f5',
      '& .MuiListItemText-primary': {
        fontWeight: 'bold'
      }
    },
    icon: {
      minWidth: 44,
      margin: "0 10px",
    },
    label: {
      fontWeight: "normal",
      "&:hover, &:active": {
        fontWeight: "bold",
      },
    },
    saFlagIcon: {
      height: 23,
      width: 23,
      marginRight: '8px'
    }
  })
);

function ListItemLink(props: ListItemLinkProps) {
  const { icon, primary, to: routeTo, drawerOpen, onMenuClick, item } = props;
  const showSAFlag: boolean = getReferringCompany() === CDSA_REFERRING_VALUE && routeTo === ACCOUNT_SECTION_ROUTE;
  const isSAdrawerOpen = !drawerOpen && showSAFlag;
  const linkClasses = useStyles();
  const renderLink = React.useMemo(
    () =>
      React.forwardRef<any, Omit<RouterLinkProps, "to">>((itemProps, ref) => (
        <RouterLink
          className={({ isActive }) => (isActive ? linkClasses.selected : "")}
          to={routeTo}
          ref={ref}
          {...itemProps}
        />
      )),
    [routeTo, linkClasses.selected]
  );

  const handleMenuClick = () => {
    if (onMenuClick) {
      onMenuClick(item);
    }
  };

  return (
    <li className={linkClasses.listItem} data-tooltip={primary} data-flow="right">
      <ListItem button className={linkClasses.selection} component={renderLink} onClick={handleMenuClick}>
        {icon ? (
          <ListItemIcon className={linkClasses.icon}>
            {isSAdrawerOpen ? <SAFlag className={linkClasses.saFlagIcon} /> : icon}
          </ListItemIcon>
        ) : null}
        <ListItemText className={linkClasses.label} primary={primary} />
        {showSAFlag && <SAFlag className={linkClasses.saFlagIcon} />}
      </ListItem>
    </li>
  );
}

export default withTranslate(ListItemLink)
